import httpService from '@/services/httpService'
// eslint-disable-next-line no-unused-vars
import LinkBuilding from '../../../features/link-building/LinkBuilding'

export const types = {
  ADD_LINKS: 'rank-zone/ADD_LINKS'
}
const emptyData = {
  links: []
}

const state = { ...emptyData }

const mutations = {
  [ types.ADD_LINKS ]: function (state, links) {
    state.links = links || []
  }
}

const actions = {
  getLinks: async function ({ commit, dispatch }, { clientId }) {
    const response = await httpService.get(`/links/list/${clientId}`)
    if (response && response.data) {
      commit(types.ADD_LINKS, response.data)
    }
  },
  resetData: function ({ commit }) {
    commit(types.ADD_LINKS, [])
  }
}

/**
 * Store keep data for {@link LinkBuilding} component
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
